import { BaseNavigatorCommand } from "./BaseNavigatorCommand";
import { ConfigGetCommand } from "./ConfigGetCommand";
import { ConfigSetCommand } from "./ConfigSetCommand";

export class ConfigCommand extends BaseNavigatorCommand
{
    constructor(argv: string[], keys: string[])
    {
        super(argv, {
            "set": (argv: string[]) => new ConfigSetCommand(argv, keys),
            "get": (argv: string[]) => new ConfigGetCommand(argv, keys)
        });
    }
}